import {
  UPDATE_PROFILE,
  PROFILE,
  EMAIL_VALIDATION,
  EMAIL_REMINDER,
} from "../constants/url";
import { message } from "antd";
import { catchErrors } from "../utils/catchErrors";
import { genericApiCall, getApiCall } from "../utils/servicesBaseUtil";
import {
  storeUserData,
  toggleProfileLoading,
  emailReminderStatus,
  isSubscriptionValid,
} from "../store/slice/profile.slice";
import { useNavigate } from "react-router-dom";

export const getProfileApi = ({
  finalCallback,
  successCallback,
  unauthenticatedCallback,
}) => {
  return (dispatch) => {
    let url = PROFILE;
    dispatch(toggleProfileLoading(true));

    getApiCall({ url: url })
      .then((responseJson) => {
        console.log(
          "responseJson",
          responseJson?.data?.subscription?.is_subscription_valid
        );
        if (responseJson?.success) {
          dispatch(
            isSubscriptionValid(
              responseJson?.data?.subscription?.is_subscription_valid ?? false
            )
          );
          successCallback(responseJson?.data);
          dispatch(storeUserData(responseJson?.data));
          dispatch(
            emailReminderStatus(responseJson?.data?.skincare_email_reminder)
          );
        } else {
          if (responseJson?.message === "Unauthenticated") {
            unauthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        dispatch(toggleProfileLoading(false));
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const updateProfileApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = `${UPDATE_PROFILE}`;

    let formData = new FormData();

    formData.append("name", data?.name);
    formData.append("phone", data?.phone);
    formData.append("profile_pic", data?.profile_pic);
    formData.append("email", data?.email);
    formData.append("subscribe", data?.subscribe ? 1 : 0);
    formData.append("_method", data?._method);

    if (data?.new_password && data?.new_password_confirmation) {
      formData.append("new_password", data?.new_password);
      formData.append(
        "new_password_confirmation",
        data?.new_password_confirmation
      );
    }

    genericApiCall({ url: url, method: "POST", data: formData })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data?.errors);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const validateEmailApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = `${EMAIL_VALIDATION}`;
    let formData = new FormData();
    formData.append("email", data?.email);
    genericApiCall({ url: url, method: "POST", data: formData })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          failureCallback(responseJson?.data);
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        message.error("Something went wrong with email validation");
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const resendEmailReminderApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = EMAIL_REMINDER;
    genericApiCall({
      url: url,
      method: "POST",
      data: JSON.stringify(data),
      ContentType: "application/json",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson?.data);
        } else {
          failureCallback(responseJson?.data);
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        message.error("Something went wrong with email verification");
      })
      .finally(() => {
        finalCallback();
      });
  };
};
